/**
 * colorPalettes.service.ts
 *
 * Typed API call wrappers for the master-account Color Palette (brand colors).
 * Each entry is one selectable color, grouped as 'primary' or 'standard'. The
 * palette is managed in the corporate dashboard and shared by every account
 * under the same master account; the email editors read it to populate their
 * color swatches.
 *
 * Uses the shared apiClient (Axios instance with JWT + X-Target-Company
 * interceptor) and returns unwrapped data from the response envelope.
 */
import { apiClient } from './apiClient';
import type { ApiResponse } from '@/types/api.types';

// ─── Domain types ─────────────────────────────────────────────────────────────

/** A brand color as returned by GET /color-palettes. Mirrors `account_brand_colors`. */
export interface PaletteColor {
  accountBrandColorID: number;
  masterAccountID: number;
  name: string;
  colorHex: string;
  colorType: 'primary' | 'standard';
  setOrder: number;
  active: number;
}

// ─── API methods ──────────────────────────────────────────────────────────────

/** Fetch the active brand colors for the account's master, ordered by setOrder. */
export function listColorPalette(): Promise<PaletteColor[]> {
  return apiClient
    .get<ApiResponse<PaletteColor[]>>('/color-palettes')
    .then((r) => r.data.data);
}
